export default "__VITE_ASSET__DZG7jPT3__"